<template>
    <span>
        <span class="filters-list__item-name" :class="{'filters-list__item-name--active' : isFacetCollapsed}" @click="isFacetCollapsed = !isFacetCollapsed">
            <span v-html="displayName"></span><i class="fa fa-caret-up"></i>
        </span>
        <ul class="filters-list__nested-list" :class="{'filters-list__nested-list--collapsed' : isFacetCollapsed}">
            <li v-show="values.length > 0" class="filters-list__nested-item">
                <div :id="sliderid"></div>
                <div class="filters-list__slider-values">
                    <span class="filters-list__slider-value-min">{{minSliderValue}}</span>
                    <span class="filters-list__slider-value-max">{{maxSliderValue}}</span>
                </div>
            </li>
            <span v-show="values.length === 0">
                No options available.
            </span>
        </ul>
    </span>
</template>

<script>
    import $ from 'jquery'
    import 'jquery-ui/ui/widgets/slider'

    export default {
        name: "RangeSlider",
        props: ['sliderid', 'values', 'displayName', 'model'],
        data () {
            return {
                originalValues: [],
                isFacetCollapsed: true,
                minValue: 0,
                maxValue: 0,
            }
        },
        computed: {
            minSliderValue: function () {
                return this.minValue;
            },
            maxSliderValue: function () {
                return this.maxValue;
            },

        },

        mounted: function () {
            var sliderId = this.sliderid;
            this.originalValues = this.values;
            var self = this;
            this.minValue = this.originalValues[0];
            this.maxValue = this.originalValues[this.originalValues.length-1];

            $(function () {

                $('#' + sliderId).slider({
                    min: 0,
                    max: self.originalValues.length - 1,
                    step: 1,
                    values: [0, self.originalValues[self.originalValues.length - 1]],
                    range: true,
                    slide: function (event, ui) {
                        // first, prevent overlapping of the slider handles
                        // if ((ui.values[0]) >= ui.values[1]) {
                        //     return false;
                        // }

                        modifyLabels(event, ui);
                    },
                    change: function(event, ui) {
                        // resetting the filters does not triggers slide event.
                        modifyLabels(event, ui);
                    },
                    stop: function (event, ui) {
                        if (self.originalValues[ui.values[1]]) {
                            let emittedValue = {};
                            emittedValue[sliderId] = self.originalValues[ui.values[0]] + ':' + self.originalValues[ui.values[1]];
                            self.updateRangeModelValue();
                            self.$emit('updateRange', emittedValue);
                        }
                    },
                });

                function modifyLabels(event, ui) {
                    if (ui.handleIndex === 0) {
                        self.minValue = self.originalValues[ui.value];
                    }

                    if (ui.handleIndex === 1) {
                        self.maxValue = self.originalValues[ui.value];
                    }
                }

            });
        },

        watch: {
            values: function(newVal, oldVal) { // watch it
                // console.log('Prop changed: ', newVal, ' | was: ', oldVal)
                if(newVal.length > 0 && this.originalValues.length > 0) {
                    if(newVal.length >= this.originalValues.length){
                        // while navigating between the components it might happens that the
                        // original values will contain the old values when the mounting happens
                        // after a new fetch/reset the original values has to be adjusted
                        //set up the original values for the slider
                        this.originalValues = newVal;
                        $('#' + this.sliderid).slider('option',{min: 0, max: this.originalValues.length-1});
                    }
                    this.refreshSlider([this.originalValues.indexOf(newVal[0]), this.originalValues.indexOf(newVal[newVal.length - 1])]);
                }
            },
        },

        methods: {
            refreshSlider(sliderValues){
                $('#' + this.sliderid).slider('values', sliderValues);
            },

            updateRangeModelValue(){
                if (this.model[this.sliderid]) {
                    this.$set(this.model, this.sliderid, this.minSliderValue + ":" + this.maxSliderValue);
                }
            }
        },

    };

</script>
